import React from 'react';
import './Support.scss';
import CustomBtn from '../../../../components/CustomBtn/CustomBtn';
import { isExternalLink, safeHtml } from '../../../../services/helpers';
import StrapiImageWithSkeleton from '../../../../components/StrapiImageWithSkeleton/StrapiImageWithSkeleton';

const Support = ({strapiData}) => {
    return (
        <section className="support">
            <h2>{strapiData.Titre}</h2>
            <div className="support__cards">
                {
                    strapiData.Cartes_Atelier.map((support) => (
                        <article key={support.id} className="support__card">
                            <StrapiImageWithSkeleton
                                picture={support.Photo}
                                loading="lazy"
                                size='small'
                            />
                            <h3>{support.Titre}</h3>
                            <p className="" dangerouslySetInnerHTML={safeHtml(support.Texte)} />
                            <CustomBtn
                                type={isExternalLink(support.Bouton.LienBouton) ? 'external' : 'internal'}
                                title={support.Bouton.TexteBouton}
                                link={
                                    support.Bouton.LienBouton === null ?
                                        ''
                                    :
                                        (isExternalLink(support.Bouton.LienBouton) ?
                                            support.Bouton.LienBouton
                                        :
                                            '/' + support.Bouton.LienBouton)
                                }
                                bkg_color={'transparent'}
                                bkg_color_hover={'#EEE6DB'}
                                text_color={'#361215'}
                                text_color_hover={'#361215'}
                                border_color={'#361215'}
                                border_color_hover={'#361215'}
                                font_family={"Great Vibes"}
                                font_size={'30px'}
                                font_weight={'500'}
                                border_radius={'3px'}
                                width={'353px'}
                                height={'60px'}
                                margin={'20px 0'}
                                letter_spacing={'3px'}
                            />
                        </article>
                    ))
                }
            </div>
        </section>
    );
};

export default Support;